import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { Loader2 } from "lucide-react";

import { GET_SESSION_FOR_PRINT } from "@/graphql/queries/sessions";
import { PrintWorksheet } from "@/components/print-worksheet";

export default function PrintSessionPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useQuery(GET_SESSION_FOR_PRINT, {
    variables: { id },
    skip: !id,
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const session = data?.sessionForPrint;

  if (!session) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Sesija nerasta</p>
      </div>
    );
  }

  if (session.exercises.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">
          Nėra užduočių spausdinimui. Pirmiausia sugeneruokite užduotis.
        </p>
      </div>
    );
  }

  return <PrintWorksheet session={session} />;
}
